// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#careimage-register[data-v-15e2dd30]{max-width:700px;margin-left:auto;margin-right:auto}#careimage-register .box-body .careimage-group[data-v-15e2dd30]{width:400px}#careimage-register .box-body .right-side[data-v-15e2dd30]{margin-left:auto}#careimage-register .cancel-btn[data-v-15e2dd30],#careimage-register .register-btn[data-v-15e2dd30]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
